<template>
    <div class="slide" :class="{'slide--active': active, 'slide--next': next,  'slide--prev': previous}" :aria-hidden="active">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        inject: ['$slider'],
        props: {
            index: {
                type: Number,
                default: 0
            }
        },
        computed: {
            active() {
                // Current Index and Not Sliding
                return this.$slider.index === this.index && !this.$slider.sliding;
            },
            next() {
                // Current Index and Sliding
                return this.$slider.index === this.index && this.$slider.sliding;
            },
            previous() {
                // Previous Index and Sliding
                return this.$slider.prevIndex === this.index && this.$slider.sliding;
            }
        }
    };
</script>

<style lang="scss">
    @import '../../sass/abstracts/variables';
    @import '../../sass/abstracts/media-queries';

    .slide {
        display: none;
        float: left;
        height: 100%;
        margin-right: -100%;
        opacity: 0;
        position: relative;
        transition: opacity 0.6s ease-in-out;
        width: 100%;

        &--active {
            opacity: 1;
            z-index: 1;
        }

        &--active, &--next, &--prev {
            display: block;
        }

        &--next {
            opacity: 1;
            z-index: 0;
        }

        &--prev {
            opacity: 0;
            z-index: 1;
        }

        &__captions {
            display: none;

            @include laptop {
                bottom: 6.8rem;
                display: block;
                left: 6.8rem;
                max-width: 67.8rem;
                padding-right: 6.8rem;
                position: absolute;
                text-shadow: $black-o-50 0 0 1rem;

                h2 {
                    font-size: 5.5rem;
                    line-height: 1.5em;
                    position: relative;

                    &:after {
                        border-bottom: 0.2rem solid #fff;
                        bottom: 0;
                        content: '';
                        left: 0;
                        position: absolute;
                        width: 25%;
                    }
                }

                p {
                    font-size: 1.8rem;
                    line-height: 1.5em;
                }

                p, h2 {
                    color: $white;
                }

                .credit {
                    font-size: 1.6rem;
                    margin-top: 5rem;
                }
            }
        }
    }
</style>